import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }

import { onMounted, getCurrentInstance } from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const { proxy } = getCurrentInstance() as any;

	onMounted(() => {
		let href = window.location.href;
		if (href.indexOf("localhost") > -1) {
			proxy.$store.commit("SetMode", 1);
		} else {
			proxy.$store.commit("SetMode", 2);
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})